module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-5.jpg?8a7e471048ca32c358fafd5ac3e49ee9";